import { createFileRoute } from '@tanstack/react-router';

import { ProjectsErrorScreen } from '../../features/projects/error-screen';
import { validateProjectListSearch } from '../../features/projects/list-filters';
import { ProjectsToastProvider } from '../../features/projects/toast';
import { VentureScreen } from '../../features/projects/venture-screen';

/**
 * `/ventures/:slug` (§1.2): نفس مكوّن قائمة المشاريع بفلتر المظلة — لا شاشة ثانية.
 */
export const Route = createFileRoute('/ventures/$slug')({
  validateSearch: validateProjectListSearch,
  component: VentureProjectsScreen,
  errorComponent: ProjectsErrorScreen,
});

function VentureProjectsScreen() {
  const { slug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ProjectsToastProvider>
      <VentureScreen
        slug={slug}
        search={search}
        onSearchChange={(next) => void navigate({ search: () => next })}
      />
    </ProjectsToastProvider>
  );
}
